export const LOGOUT_USER = 'LOGOUT_USER';

export const logoutUser = () => ({type: LOGOUT_USER});
